.backButton {
  cursor: pointer;
  margin-right: 29px;
  margin-left: 26px;
  margin-top: 28px;
  height: fit-content;
}

.backButtonAnnouncement {
  @extend .backButton;
  margin-top: 97px;
}
